"use client";

import dynamic from "next/dynamic";

export const DevTools = dynamic(() =>
	import("./DevToolsRendered").then((mod) => mod.DevToolsRendered),
);
